import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
 } from '@angular/common/http';
 import { HTTP_INTERCEPTORS } from '@angular/common/http';
 import {InstiService} from './insti.service';
 import { retry } from 'rxjs/operators'; 
 import { catchError, retryWhen, delay, concatMap } from 'rxjs/operators'; 
 import { throwError, of } from 'rxjs'; 
 import Swal from 'sweetalert2'
 import { instiRoutehandle } from './instiRoutehandle.module';
 //@Injectable()
 const insti_service =InstiService;
 
 export const retryCount = 1;
 export const retryWaitMilliSeconds = 1000;

export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(private insti_route: instiRoutehandle,
    protected service: InstiService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if(req.url=='xxx'){
    }

    if(req.params.get('isExternal') == 'true'){
      return next.handle(req);
    }
    
    var inst_class=new insti_service();
 /*  
  const dupReq = req.clone({
      //// if(req.method=='POST'){
        
   headers: req.headers
    .set('Authorization','Bearer '+inst_class.getAuthorization())
    .set('X-CSRF-TOKEN', inst_class.getCsrToken())
    .set('Content-Type','application/json; charset=utf-8'),
   //params: req.params.set('_token', inst_class.getCsrToken()),
 });
 */ 

  // Adicionar o cabeçalho 'empresa-selecionada' com o valor do localStorage
  const empresaSelecionada = localStorage.getItem('empresa_selecionada') || '0';
  
  const headers = req.headers.set('empresa-selecionada', empresaSelecionada);
  const dupReq = req.clone({ headers: inst_class.headerInTerpolation(headers)});
 
 let instance = this;
  return next.handle(dupReq).pipe(
    retryWhen(error => 
      error.pipe(
        concatMap((error, count) => {
          if (count < retryCount && (error.error.msg.indexOf('deadlock') !== -1 || error.error.msg.indexOf('fopen') !== -1)){
            return of(error);
          }
          return throwError(error);
        }),
        delay(retryWaitMilliSeconds)
      )
    ),
    catchError((error: HttpErrorResponse) => {

      if (error.statusText === "Unknown Error") {
        instance.insti_route.getRoutObj().navigate([instance.service.getLoginUrl(true)]);
        Swal.fire({
          title: "Atenção!",
          html:"Não foi possível acessar a aplicação. Verifique se você está conectado na rede corporativa.",
          type: "warning",
          showCancelButton: false,
          showConfirmButton: true,
        });
      }   

      else if (error.status === 301 || error.status === 419) {
        instance.insti_route.getRoutObj().navigate([instance.service.getLoginUrl(true)]);
        Swal.fire({
          title: "Atenção!",
          html:"Token inválido. Faça o login novamente.",
          type: "warning",
          showCancelButton: false,
          showConfirmButton: true,
        });
      }      
      return throwError(error);
    })
  );
 
//  return next.handle(dupReq);
 }
}
    
    
@NgModule({
providers: [
 {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpsRequestInterceptor,
  multi: true,
 },
],
})
    
    
export class Interceptor {}